/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetOrderStakeholdersWithDataQuery } from '../../models/get-order-stakeholders-with-data-query';
import { GetOrderStakeholdersWithDataQueryResult } from '../../models/get-order-stakeholders-with-data-query-result';

export interface ApiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Params {
      body?: GetOrderStakeholdersWithDataQuery
}

export function apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost$Params, context?: HttpContext): Observable<StrictHttpResponse<GetOrderStakeholdersWithDataQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetOrderStakeholdersWithDataQueryResult>;
    })
  );
}

apiNurseryManagerOrderStakeholderGetOrderStakeholdersWithDataPost.PATH = '/api/NurseryManager/OrderStakeholder/GetOrderStakeholdersWithData';
